import { createStepsContextProvider } from '@fiverr-private/identification_core';
import { StepId } from '../../shared/constants/stepId';

const { StepsContextProvider, useStepsContext } = createStepsContextProvider<StepId>();

export { StepsContextProvider, useStepsContext };
